module.exports = __webpack_public_path__ + "img/lessoner.b7133563.png";